<ion-header>
  <ion-row class="ion-align-items-center">
    <div class="column">
      <div class="back" (click)="back()">
        <img src="assets/icon/back.svg" alt="" />
      </div>
      <div class="logo">
        @if (isEdit) {
          <span>Edit Combo</span>
        }
        @if (!isEdit) {
          <span>Add Combo</span>
        }
      </div>
    </div>
  </ion-row>
</ion-header>

<ion-content>
  <ion-item class="default-input">
    <ion-input
      [(ngModel)]="comboPrice"
      (ngModelChange)="comboPriceChange.next($event)"
      [placeholder]="'Enter Combo price'"
      label="Expected Combo Price"
      labelPlacement="stacked"
      type="number"
      >
    </ion-input>
  </ion-item>

  <!-- Totals -->
  <div>
    <p>Original Total: {{ utils.formatMoneyByMerchant(totals.originalTotal, activeMerchant) }}</p>
    <p>
      Combo Total: {{ utils.formatMoneyByMerchant(totals.comboTotal, activeMerchant) }} ({{
      totals.factor
      }})
    </p>
  </div>

  <!-- Product List -->
  @for (product of activeProducts; track product._id; let i = $index) {
    <div class="product-view">
      <div class="product-info">
        <div class="product-view__image">
          @if (product.images && localImages[product.images[0]]?.thumbnail) {
            <img
              [src]="localImages[product.images[0]]?.thumbnail"
              />
          }
        </div>
        <div class="wrap">
          <div class="product-view__name">{{ product.name }}</div>
          <div class="product-view__price">
            {{ utils.formatMoneyByMerchant(product.comboProduct.price, activeMerchant) }}
          </div>
          <div class="product-view__quantity">
            <div class="quantity-picker">
              <button (click)="decreaseQuantity(product)">-</button>
              <span>{{ product.comboProduct.quantity }}</span>
              <button (click)="increaseQuantity(product)">+</button>
            </div>
          </div>
        </div>
        <div class="remove" (click)="remove(i)">
          <img src="../../../assets/icon/combo-delete.svg" alt="" />
        </div>
      </div>
    </div>
  }

  @if (activeProducts.length < 5) {
    <button class="action-btn small" (click)="openProductModal()">
      + Add Product
    </button>
  }

  <button class="action-btn" style="margin-bottom: 20px" (click)="save()">
    @if (isEdit) {
      <span>Update</span>
      } @if (!isEdit) {
      <span>Save</span>
    }
  </button>
</ion-content>
